import _ from 'underscore';

import { ProjectionGridBaseColumn } from '@bingads-webui/projection-grid-base-column';
import template from './one-line-text.pug';

export class EditedByColumn extends ProjectionGridBaseColumn {
  constructor({ i18n }) {
    super({
      name: 'EditedBy',
      property: 'RecommendationResult/EditedBy',
      title: i18n.getString('ColumnName_EditedBy'),
      bodyClasses: ['grid-column-editted-by'],
      colClasses: ['col-text'],
      type: 'string',
    });
  }

  template({
    value: {
      EditorName,
    },
  }) {
    return template({ content: EditorName });
  }

  get property() {
    return {
      get: _.identity,
    };
  }
}
